import {
  FETCH_QUESTIONS_PENDING,
  FETCH_QUESTIONS_REJECTED,
  FETCH_QUESTIONS_FULFILLED,
} from '../constants/calculateQuestions';

const initialState = {
  pending: true,
  questions: {},
  error: {},
  success: false,
};

export const calculateQuestions = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_QUESTIONS_FULFILLED:
      return {
        ...state,
        questionsData: action.response,
        pending: false,
        success: true,
      };

    case FETCH_QUESTIONS_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_QUESTIONS_PENDING:
      return {
        ...state,
        error: {},
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/calculateQuestions.js